var map = {
	"./app.js": 2056,
	"./caseDeclaration.js": 8727,
	"./certificationTesting.js": 373,
	"./cloudResource.js": 1026,
	"./enterprises.js": 227,
	"./expert.js": 9031,
	"./financialService.js": 6997,
	"./homeData.js": 260,
	"./lectureHall.js": 1686,
	"./news.js": 6252,
	"./organizationModule.js": 2368,
	"./policyRelevant.js": 84,
	"./researchInstitutes.js": 874,
	"./saasApp.js": 1008,
	"./scientificResults.js": 9750,
	"./skillsCompetition.js": 5926,
	"./solution.js": 3532,
	"./successCases.js": 8307,
	"./supplyDemand.js": 8503,
	"./trainingPractice.js": 128,
	"./universities.js": 2075,
	"./user.js": 2296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4870;